/** Canonical production origin (no trailing slash). */
export const SITE_ORIGIN = 'https://www.eventa.tv'

export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/eventaCover.jpg`

export function stripHtmlToText(raw: string): string {
  return raw
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

/** Google typically shows ~150–160 characters for descriptions. */
export function truncateMetaDescription(text: string, maxLen = 158): string {
  const t = text.replace(/\s+/g, ' ').trim()
  if (t.length <= maxLen) return t
  return `${t.slice(0, maxLen - 1).trimEnd()}…`
}
